import { createContext } from 'react';
import utils from 'utils';

type ReleaseFileLoadingContextValue = {
  isReleaseFileLoadingForLead: (
    leadId: string,
    dataRoomNodeId: string,
  ) => boolean;
  setReleaseFileLoadingForLead: (
    leadId: string,
    dataRoomNodeId: string,
    loading: boolean,
  ) => void;
};

export default createContext<ReleaseFileLoadingContextValue>({
  isReleaseFileLoadingForLead: utils.noop,
  setReleaseFileLoadingForLead: utils.noop,
});
